import { jsx as l, Fragment as g } from "react/jsx-runtime";
import { highlightTextWithinItems as c } from "./index.es547.js";
import { useMemo as s, useCallback as I } from "react";
import { onItemClick as M } from "./index.es2384.js";
import { noop as C } from "lodash/fp";
import { MenuListContainer as a } from "./index.es82.js";
import { BASIC_MENU_ITEM_HEIGHT as d } from "./index.es77.js";
import { MultiSelectItem as S } from "./index.es78.js";
const F = ({
  items: t,
  maxVisibleItems: u,
  onSelection: m,
  onItemSelection: n = C,
  searchTerm: o,
  NoResultsItem: p
}) => {
  const r = s(
    () => c({
      searchTerm: o,
      items: t,
      shouldFilter: !0
    }),
    [t, o]
  ), h = I(
    (e) => {
      M(t, e, "multiple", n, m);
    },
    [t, n, m]
  );
  return /* @__PURE__ */ l(
    a,
    {
      itemHeight: d,
      itemCount: o ? r.length : t.length,
      maxVisibleItems: u,
      NoResults: p,
      children: ({ index: e, style: f }) => {
        const i = r[e];
        return i ? /* @__PURE__ */ l(
          S,
          {
            onItemSelect: h,
            ...i,
            hasDivider: e < r.length - 1,
            wrapperStyle: f
          },
          i.value
        ) : /* @__PURE__ */ l(g, {});
      }
    }
  );
};
export {
  F as MultiSelectDropdownMenu
};
//# sourceMappingURL=index.es71.js.map
